export function setHistorico(state) {
  state.historico.push({
    ...state.jornada,
    idx: state.historico.length + 1
  })
}
